<template>
  <div class="clickable" @click="onGroupRemove">
    <i class="mdi mdi-close-circle-outline"></i>
    Eliminar grupo
  </div>
</template>

<script>
export default {
  name: 'GroupRemoveBtn',
  props: {
    nodes: Array,
    id: [Number, String]
  },
  methods: {
    onGroupRemove () {
      this.$emit('group-remove', this.id)
    }
  }
}
</script>
